import Swal from 'sweetalert2';
import videoCRUDServiceInstance from '../../services/VideoCRUDService';
import { videoCanOpen, videoNotReadyMessage } from './taskUi';

/**
 * Opens a task's file in its editor, the same way the Files browser does. Videos need the app's
 * setCanNavigateToEdit; without it we fall back to showing the file's folder. language (the
 * editor's name for it) opens that language directly in the video and text editors.
 */
export const openInEditor = async ({ contentType, contentId, folderPath, navigate, setCanNavigateToEdit, language }) => {
    if (contentType === 'TEXT') {
        navigate(`/textfiles/edit/${contentId}${language ? `?lang=${encodeURIComponent(language)}` : ''}`);
        return;
    }
    if (contentType === 'BOOK') {
        navigate(`/idml/books/edit/${contentId}`);
        return;
    }
    // A post's work is in its drawer; a video post opens the editor from there
    if (contentType === 'POST') {
        return;
    }
    if (!setCanNavigateToEdit) {
        showInFiles({ folderPath, navigate });
        return;
    }
    try {
        const user = JSON.parse(localStorage.getItem('authUser')) || {};
        const response = await videoCRUDServiceInstance.getVideoById(contentId, user.email, user.access);
        const video = response.data;
        if (!videoCanOpen(video)) {
            Swal.fire(videoNotReadyMessage(video));
            return;
        }
        ['breadcrumbs', 'subtitle', 'timelineProps', 'checkedForDelete', 'lang'].forEach((k) => localStorage.removeItem(k));
        localStorage.setItem('videoProps', JSON.stringify(video));
        localStorage.setItem('breadcrumbs', JSON.stringify((folderPath || '').split('/').filter(Boolean)));
        setCanNavigateToEdit(true);
        navigate('/videos/edit-v2', { state: { videoData: video, selectedLanguage: language } });
    } catch (e) {
        Swal.fire({ title: 'Error', text: 'Failed to load the video. Please try again.', icon: 'error' });
    }
};

/** Opens the Files browser at a folder. */
export const showInFiles = ({ folderPath, navigate }) => {
    navigate('/', { state: { navigateToFolder: folderPath || '/' } });
};
